import { Component, OnInit } from '@angular/core';
import { UserSearchType } from '../shared/types/UserSearchType.enum';
import { RetrievalType } from '../shared/types/RetrievalType.enum';
import { VueServerMessage } from '@vue/vueframework';
import { User } from '../shared/types/User';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../shared/services/account.service';
import { AppTranslationService } from '../app-translation.service';
import { AccountRecoveryUtil } from '../shared/utils/accountrecovery.utils';
import { SessionDataService } from '../shared/services/session-data.service';

@Component({
  selector: 'app-retrieve-password',
  standalone: false,
  styleUrls: [ './retrieve-password.component.css' ],
  templateUrl: './retrieve-password.component.html'
})
export class RetrievePasswordComponent implements OnInit {
  public searchType = UserSearchType.USERNAME;
  public readonly ACCOUNT_RECOVERY_BUNDLE_NAME = 'AccountRecovery';
  public retrievalType = RetrievalType;
  public messages: VueServerMessage[] = [];
  public translations = {
    pageTitle: ''
  };
  public clientCode: string;
  public user: User = {
    clientStudentID: '',
    email: '',
    firstName: '',
    lastName: '',
    userName: ''
  };

  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accountService: AccountService,
    private appTranslationService: AppTranslationService,
    private accountRecoveryUtil: AccountRecoveryUtil,
    private sessionDataService: SessionDataService
  ) { }

  public ngOnInit(): void {
    this.clientCode = this.route.snapshot.params.clientCode;

    /* Populate userName when navigating from display-userName page */
    this.user.userName = this.sessionDataService.getUser() ?
      this.sessionDataService.getUser().userName : '';
    this.getTranslations();
  }

  /**
   * Returns the candidate to the login page.
   */
  public returnToLogin(): void {
    this.accountRecoveryUtil.navigateToLogin();
  }

  public viewPasswordResetOptions(): void {
    this.accountRecoveryUtil.navigateToResetOptionsPW(this.route.snapshot.params.clientCode);
  }

  private getTranslations(): void {
    this.translations.pageTitle = this.appTranslationService.getTranslation(this.ACCOUNT_RECOVERY_BUNDLE_NAME,
      'RetrievePasswordComponent.PageTitle');
  }
}
